// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"663":"5fc07fc8","938":"3424b0fc"}[chunkId] + ".chunk.css";
};